export enum PurchaseInvoiceType{
  PERSON_INVOICE = "personInvoice",
  COMPANY_INVOICE = "companyInvoice"
}
